import { ApiVersion, BaseService } from '~services/api'

export const GetAllPushNotifications = (
  Uid: string,
  access: string,
  client: string,
  pageInfo: { per_page: string; page: string },
) => {
  return BaseService.get(
    `/institution_api/v1/push_notifications/?per_page=${pageInfo.per_page}&page=${pageInfo.page}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Client: client,
        APP_VERSION: ApiVersion,
        Uid: Uid,
        'Access-Token': access,
      },
    },
  )
}

export const EditPushNotifications = (Uid: string, access: string, client: string, id: string, data: any) => {
  return BaseService.put(
    `/institution_api/v1/push_notifications/` + id,
    {
      push_notification: data,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Client: client,
        APP_VERSION: ApiVersion,
        Uid: Uid,
        'Access-Token': access,
      },
    },
  )
}

export const DeletePushNotifications = (Uid: string, access: string, client: string, id: string, type: string) => {
  return BaseService.delete(type + id, {
    headers: {
      'Content-Type': 'application/json',
      Client: client,
      APP_VERSION: ApiVersion,
      Uid: Uid,
      'Access-Token': access,
    },
  })
}

export const CreatePushNotifications = (Uid: string, access: string, client: string, data: any) => {
  return BaseService.post(
    `/institution_api/v1/push_notifications`,
    {
      push_notification: data,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Client: client,
        APP_VERSION: ApiVersion,
        Uid: Uid,
        'Access-Token': access,
      },
    },
  )
}
